export const safeParse = (str) => {
    if (!str) return {};
    try {
        return JSON.parse(str);
    } catch {
        return {};
    }
};
